import React, { memo } from 'react';
import { NodeProps } from 'reactflow';
import { Clock, Shuffle, Briefcase, Calendar } from 'lucide-react';
import WhatsAppStyleNode from './WhatsAppStyleNode';
import { DelayNodeData } from '../../types/nodes';

const delayIcons = {
  fixed: <Clock />,
  random: <Shuffle />,
  business_hours: <Briefcase />,
  custom_schedule: <Calendar />
};

const delayLabels = {
  fixed: 'Ritardo Fisso',
  random: 'Ritardo Casuale',
  business_hours: 'Orari Lavorativi',
  custom_schedule: 'Programma Custom'
};

const DelayNode: React.FC<NodeProps<DelayNodeData>> = memo(({ selected, data }) => {
  const icon = delayIcons[data.delayType] || <Clock />;
  const label = delayLabels[data.delayType] || 'Ritardo';
  
  const getPreview = () => {
    switch (data.delayType) {
      case 'fixed':
        return `${data.config.delayTime || 0} ${data.config.delayUnit || 'secondi'}`;
      case 'random':
        return `${data.config.minDelay || 0}-${data.config.maxDelay || 60}s`;
      case 'business_hours':
        return data.config.businessHours ? `${data.config.businessHours.start} - ${data.config.businessHours.end}` : '9:00 - 18:00';
      case 'custom_schedule':
        return 'Programma personalizzato';
      default:
        return null;
    }
  };

  return (
    <WhatsAppStyleNode
      selected={selected}
      icon={icon}
      label={label}
      preview={getPreview()}
      color="from-amber-500 to-yellow-600"
      handles={{
        target: true,
        source: true,
      }}
    />
  );
});

DelayNode.displayName = 'DelayNode';

export default DelayNode;
